import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import * as common from "@/javascripts/common.js";

export default class extends Controller {
  static targets = ["reception", "showAllButton"];

  connect() {
    if (this.hasReceptionTarget && this.hasShowAllButtonTarget) {
      this.initializeHiddenItems();
    }
    this.#updateToggle();
  }

  initializeHiddenItems() {
    this.hiddenItems = this.receptions.slice(3);

    // 初期状態で4番目以降のアイテムを非表示にする
    $(this.hiddenItems).hide();
  }

  // 受付の表示状態を切り替える
  toggle() {
    this.showAllButton.classList.toggle("is-open");
    this.#updateToggle();
  }

  // modal_controller.jsのshowを呼び出す
  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById(targetId),
      "modal",
    );
    modalController.show();
  }

  htmlScroll() {
    common.HtmlScroll();
  }

  get receptions() {
    return this.receptionTargets;
  }

  get showAllButton() {
    return this.showAllButtonTarget;
  }

  // 受付の表示状態を更新する
  #updateToggle() {
    if (this.showAllButton.classList.contains("is-open")) {
      $(this.hiddenItems).fadeIn();
      this.showAllButton.textContent = this.showAllButton.dataset.openedText;
    } else {
      const previousTop = this.showAllButton.getBoundingClientRect().top;
      $(this.hiddenItems).fadeOut(() => {
        // showAllButtonが画面上端より上にあればスクロールする
        const rect = this.showAllButton.getBoundingClientRect();
        if (rect.bottom < 0) {
          const scrollTop = window.scrollY + (rect.top - previousTop);
          window.scrollTo({ top: scrollTop, behavior: "smooth" });
        }
      });
      this.showAllButton.textContent = this.showAllButton.dataset.closedText;
    }
  }
}
